(function () {
    'use strict';

    angular
        .module('surveyCampaignControllers')
        .controller('CampaignPartBuilderController', Controller);

    Controller.$inject = ['$scope', '$state', 'topBarService', 'surveyCampaignService', 'campaign', 'part'];

    function Controller($scope, $state, topBarService, surveyCampaignService, campaign, part) {
        $scope.campaign               = campaign;
        $scope.campaignPart           = part;
        $scope.campaignPartComponents = getComponents();
        $scope.isOrderingComponents   = $state.current.data && $state.current.data.isOrderingComponents;

        $scope.isQuestion = function (component) {
            return component.ComponentType === 'Question';
        };

        $scope.isVisualComponent = function (component) {
            return component.ComponentType === 'VisualComponent';
        };

        $scope.moveUpComponent = function (componentIdx) {
            if (componentIdx === 0) { return; }

            var newIdx = componentIdx - 1;
            swapComponents(componentIdx, newIdx)
        };

        $scope.moveDownComponent = function (componentIdx) {
            if ($scope.isComponentLast(componentIdx)) { return; }

            var newIdx = componentIdx + 1;
            swapComponents(componentIdx, newIdx)
        };

        $scope.isComponentLast = function (componentIdx) {
            return componentIdx === ($scope.campaignPartComponents.length - 1);
        }

        $scope.saveComponentsOrder = function () {
            surveyCampaignService
                .orderCampaignPartComponents(campaign.SlugObject, part.CampaignPartID, $scope.campaignPartComponents)
                .then(function () {
                    $scope.goBackToBuilder();
                });
        };

        $scope.duplicateQuestion = function (question) {
            var componentIdx = _.findIndex($scope.campaignPartComponents, { CampaignComponentID: question.CampaignComponentID }) + 1;

            return surveyCampaignService
                    .duplicateQuestion(campaign.SlugObject, part.CampaignPartID, question)
                    .then(function (duplicatedQuestion) {
                        duplicatedQuestion.OrderNumber = question.OrderNumber + 1;
                        $scope.campaignPartComponents.splice(componentIdx, 0, duplicatedQuestion);
                        $scope.saveComponentsOrder();
                    });
        }

        $scope.removeQuestion = function (question) {
            return surveyCampaignService
                .deleteQuestion(campaign.SlugObject, part.CampaignPartID, question)
                .then(function () {
                    $scope.campaignPartComponents = _.reject($scope.campaignPartComponents, { QuestionID: question.QuestionID });
                });
        }

        $scope.updateQuestion = function (question) {
            return surveyCampaignService.updateQuestion(campaign.SlugObject, part.CampaignPartID, question);
        }

        $scope.addQuestionChoice = function (question, choice) {
            return surveyCampaignService.createQuestionChoice(campaign.SlugObject, part.CampaignPartID, question.QuestionID, choice);
        };

        $scope.removeQuestionChoice = function (question, choice) {
           return surveyCampaignService.deleteQuestionChoice(campaign.SlugObject, part.CampaignPartID, question.QuestionID, choice);
        };

        $scope.updateQuestionChoice = function (question, choice) {
            return surveyCampaignService.updateQuestionChoice(campaign.SlugObject, part.CampaignPartID, question.QuestionID, choice);
        };

        $scope.removeVisualComponent = function (visualComponent) {
            return surveyCampaignService
                .deleteVisualComponent(campaign.SlugObject, part.CampaignPartID, visualComponent)
                .then(function () {
                    $scope.campaignPartComponents = _.reject($scope.campaignPartComponents, { VisualComponentID: visualComponent.VisualComponentID });
                });
        };

        $scope.goBackToBuilder = function () {
            $state.go('survey.campaign.slug.part.builder', {}, { reload: true });
        };

        topBarService.setTitleAndIcon(campaign.TitleEN, 'fa fa-bullhorn', 'Questionnaire Builder', 'fa fa-list-alt');

        // Helpers
        function getComponents() {
            return _.chain(part.Components)
                    .map(function (component) {
                        if (component.ComponentType === 'Question') {
                            return part.QuestionsByID[component.CampaignComponentID];
                        } else if (component.ComponentType === 'VisualComponent') {
                            return part.VisualComponentsByID[component.CampaignComponentID];
                        }
                    })
                    .value();
        }

        function swapComponents(componentIdx, newIdx) {
            var currentComponentAtNewIdx = $scope.campaignPartComponents[newIdx];

            $scope.campaignPartComponents[newIdx] = $scope.campaignPartComponents[componentIdx];
            $scope.campaignPartComponents[componentIdx] = currentComponentAtNewIdx;
        }
    }
})();